import { formatFieldName } from '@/controllers/utils'

export const validationMessages = {
  en: {
    messages: {
      required: (fieldName) => {
        return `${formatFieldName(fieldName)} cannot be blank`
      },
      is: (fieldName, referenceFieldName) => {
        return `${formatFieldName(fieldName)} must be the same`
      }
    }
  }
}

export default validationMessages
